/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createCommissionAgreementAsync } from '../fn/commission-agreement/create-commission-agreement-async';
import { CreateCommissionAgreementAsync$Params } from '../fn/commission-agreement/create-commission-agreement-async';
import { createCommissionAgreementAsync$Plain } from '../fn/commission-agreement/create-commission-agreement-async-plain';
import { CreateCommissionAgreementAsync$Plain$Params } from '../fn/commission-agreement/create-commission-agreement-async-plain';
import { Int32ApiResponse } from '../models/int-32-api-response';

@Injectable({ providedIn: 'root' })
export class CommissionAgreementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createCommissionAgreementAsync()` */
  static readonly CreateCommissionAgreementAsyncPath = '/api/commission-agreement/{contractId}';

  /**
   * Create Commission agreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCommissionAgreementAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createCommissionAgreementAsync$Plain$Response(params: CreateCommissionAgreementAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiResponse>> {
    return createCommissionAgreementAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Commission agreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCommissionAgreementAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createCommissionAgreementAsync$Plain(params: CreateCommissionAgreementAsync$Plain$Params, context?: HttpContext): Observable<Int32ApiResponse> {
    return this.createCommissionAgreementAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Int32ApiResponse>): Int32ApiResponse => r.body)
    );
  }

  /**
   * Create Commission agreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCommissionAgreementAsync()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createCommissionAgreementAsync$Response(params: CreateCommissionAgreementAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiResponse>> {
    return createCommissionAgreementAsync(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Commission agreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCommissionAgreementAsync$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createCommissionAgreementAsync(params: CreateCommissionAgreementAsync$Params, context?: HttpContext): Observable<Int32ApiResponse> {
    return this.createCommissionAgreementAsync$Response(params, context).pipe(
      map((r: StrictHttpResponse<Int32ApiResponse>): Int32ApiResponse => r.body)
    );
  }

}
